const FORMAT = 'YYYY-MM';
const MIN_GRID_COL_WIDTH = 450;
const MIN_GRID_COL_HEIGHT = 360;
const GRID_HEADER_HEIGHT = 40;
const CHART_HEIGHT = MIN_GRID_COL_HEIGHT - GRID_HEADER_HEIGHT;
const TEXT_HEIGHT_ABOVE_INVOICE_CHART = 85;
const CHARTS_PER_ROW = 3;
const DEFAULT_CHART_POSITIONS = [
  'invoice',
  'delivery',
  'reaction',
  'campaign-count',
  'device-distribution',
  'conversion-price',
].map((name, index) => {
  index += 1;
  const row = Math.ceil(index / CHARTS_PER_ROW);
  const col = index % CHARTS_PER_ROW === 0
    ? CHARTS_PER_ROW
    : index % CHARTS_PER_ROW;

  const chart = {
    name,
    row,
    col,
    size_x: 1,
    size_y: 1,
    chart_width: MIN_GRID_COL_WIDTH,
    chart_height: CHART_HEIGHT,
  };

  // The invoice chart has some text above itself so
  // We need to reduce the text's height in order to
  // Fit the chart within it's grid
  if(name === 'invoice') {
    chart.chart_height -= TEXT_HEIGHT_ABOVE_INVOICE_CHART;
  }

  return chart;
});

angular.module('zc').component('zcDashboard', {
  templateUrl: '/templates/projects.dashboard/dashboard.html',
  bindings: { project: '<' },
  controller: zcDashboardController
});

zcDashboardController.$inject = [
  '$timeout',
  '$translate',
  'Apollo',
  'DashboardChartPositions',
  'Page',
  'Project',
];

function zcDashboardController(
  $timeout,
  $translate,
  Apollo,
  DashboardChartPositions,
  Page,
  Project
) {
  const vm = this;
  const thisMonthStartAt = moment().tz(Project.getRegion()).startOf('month').toDate();
  const thisMonthEndAt = moment(thisMonthStartAt).add(1, 'month').toDate();
  const lastMonthStartAt = moment(thisMonthStartAt).subtract(1, 'month').toDate();
  const lastYearStartAt = moment(thisMonthStartAt).subtract(1, 'year').toDate();

  let gridster;

  Page.setBodyClass('');
  $translate('projectsDashboard.dashboard.dashboard').then(function(translation) {
    Page.setTitle(translation);
  });

  vm.$onInit = () => {
    getProject()
      .then(project => {
        vm.project = _.assignIn({}, vm.project, project);
      })
      .then(() => DashboardChartPositions.get())
      .then(chart => {
        vm.hasSavedChartPositions = chart.positions !== null;
        vm.chartPositions = vm.hasSavedChartPositions
          ? chart.positions
          : DEFAULT_CHART_POSITIONS;
      });
  };

  function getChart($widget) {
    const chartScope = angular
      .element($widget.find('.chart-component'))
      .scope();

    return _.get(chartScope, '$$childHead.config').getHighcharts();
  }

  vm.initGrid = function() {
    // XXX: Wait for the dashboard.html to render completely,
    // because all the data-XXX attribute values must be set before initializing gridster
    $timeout(function() {
      gridster = $('.gridster ul')
        .gridster({
          widget_base_dimensions: [MIN_GRID_COL_WIDTH, MIN_GRID_COL_HEIGHT],

          // Custom function for serializing the charts. Created in order to
          // add the name parameter to keep track which chart is moved where
          serialize_params: function($widget, wgd) {
            const chart = getChart($widget);
            return {
              name: $widget.attr('id'),
              col: wgd.col,
              row: wgd.row,
              size_x: wgd.size_x,
              size_y: wgd.size_y,
              chart_width: chart.chartWidth,
              chart_height: chart.chartHeight
            };
          },

          draggable: {
            stop: function(e, ui, $widget) {
              saveGrid();
            }
          },

          resize: {
            enabled: true,
            max_size: [2, 2],
            min_size: [1, 1],
            // Resize a chart and save the changes to DB
            stop: function(e, ui, $widget) {
              const isWidgetResized =
                this.resize_initial_sizex !== this.resize_last_sizex ||
                this.resize_initial_sizey !== this.resize_last_sizey;

              if(!isWidgetResized) {
                return;
              }

              const chart = getChart($widget);

              const newWidth = MIN_GRID_COL_WIDTH * this.resize_last_sizex;
              let newHeight = MIN_GRID_COL_HEIGHT * this.resize_last_sizey;
              newHeight -= chart.container.offsetTop;

              chart.setSize(newWidth, newHeight);

              saveGrid();
            }
          }
        })
        .data('gridster');
    });
  };

  function saveGrid() {
    const grid = gridster.serialize();

    if(vm.hasSavedChartPositions) {
      DashboardChartPositions.update(grid);
    } else {
      DashboardChartPositions.create(grid);
      vm.hasSavedChartPositions = true;
    }
  }

  function getProject() {
    return Apollo.query(gql(`{
      project(apikey: "${vm.project.apikey}") {
        minimum_charge
        product_line
        campaigns(start_at: {lt: "${thisMonthEndAt.toISOString()}"}, end_at: {gte: "${thisMonthStartAt.toISOString()}"}) {
          id
          status
          start_at
          end_at
        }
        invoices(start_at: {gte: "${lastYearStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          invoice_price_tax_excluded
          start_at
        }
        zcs_invoices(start_at: {gte: "${lastYearStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          invoice_price_tax_excluded
          month
        }
        dailyCampaignEventStats(start_at: {gte: "${thisMonthStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          count
          start_at
        }
        monthlyStats: monthlySiteReportStats(start_at: {gte: "${lastYearStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          all_campaign {
            session_count
            conversion_price
          }
          devices {
            device
            session_count
          }
          start_at
        }
        dailyReportStats: dailyReportStats(start_at: {gte: "${thisMonthStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          start_at
          invoice_amount
        }
        dailyStats: dailySiteReportStats(start_at: {gte: "${thisMonthStartAt.toISOString()}", lt: "${thisMonthEndAt.toISOString()}"}) {
          start_at
          all_access {
            session_count
            conversion_price
          }
          all_campaign {
            reaction_count
            session_count
            conversion_price
          }
        }
      }
    }`))
      .then(res => res.project)
      .then(reduceProject);
  }

  function reduceProject(project) {
    project = _.cloneDeep(project);

    project.thisMonthStat = _.find(project.monthlyStats, { start_at: thisMonthStartAt.toISOString() });
    project.lastMonthStat = _.find(project.monthlyStats, { start_at: lastMonthStartAt.toISOString() });
    if(project.product_line === 'zenclerk_s') {
      project.thisMonthInvoice = _.find(project.zcs_invoices, { month: moment(thisMonthStartAt).format(FORMAT) });
      project.lastMonthInvoice = _.find(project.zcs_invoices, { month: moment(lastMonthStartAt).format(FORMAT) });
    } else {
      project.thisMonthInvoice = _.find(project.invoices, { start_at: thisMonthStartAt.toISOString() });
      project.lastMonthInvoice = _.find(project.invoices, { start_at: lastMonthStartAt.toISOString() });
    }

    return project;
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.dashboard/dashboard.controller.js